import { serviceAPI } from './api';

export type PhotoCategory = 'before' | 'after';

export interface ServicePhoto {
  id: string;
  appointment_id: string;
  property_id?: string;
  property_name?: string;
  client_name?: string;
  employee_name?: string;
  category: PhotoCategory;
  description?: string;
  room_name?: string;
  tags?: string[];
  original_url?: string;
  optimized_url?: string;
  thumbnail_url?: string;
  url?: string;
  created_at?: string;
}

export const getPhotosByAppointment = async (appointmentId: string): Promise<ServicePhoto[]> => {
  const { data } = await serviceAPI.get<ServicePhoto[]>(`/service-photos/appointment/${appointmentId}`);
  return Array.isArray(data) ? data : [];
};

export const getPhotoGalleryByProperty = async (propertyId: string) => {
  const { data } = await serviceAPI.get(`/service-photos/property/${propertyId}/gallery`);
  return data;
};

